<template>
    <div class="d-flex flex-column">
        <div v-if="show_class && !!o_data.instrument_class">CLASSE: <b>{{instr_class}}</b></div>
        <div v-switch="family">
            <span v-case="`bilancia nawi`" ref="bilancia nawi">
                <span v-for="(range, idx) in o_data.ranges" :key="idx">
                    <span v-if="!!range.max">max: {{ range.max | formatNumber }}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<span v-if="instr_class && !!range.e"> - e: {{range.e | formatNumber}}{{o_data.uom}}</span><br/></span>
                </span>
            </span>
            <span v-case="`bilancia nawi meccanica`" ref="bilancia nawi meccanica">
                <span v-for="(range, idx) in o_data.ranges" :key="idx">
                    <span v-if="!!range.max">portata max: {{ range.max | formatNumber }}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<span v-if="instr_class && !!range.e"> - e:{{range.e | formatNumber }}{{o_data.uom}}</span><br/></span>
                </span>
            </span>
            <span v-case="'bilancia awi X'" ref="'bilancia awi X'">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max">max: {{ range.max | formatNumber }}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<span v-if="instr_class && !!range.e"> - e: {{range.e | formatNumber}}{{o_data.uom}}</span><br/></span></span></span>
            <span v-case="'bilancia awi Y'" ref="'bilancia awi Y'">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max">max: {{ range.max | formatNumber }}{{ o_data.uom }} - d: {{range.d | formatNumber }}{{o_data.uom}}<span v-if="instr_class && !!range.e"> - e: {{range.e | formatNumber}}{{o_data.uom}}</span><br/></span></span></span>
            <span v-case="'termometro'" ref="'termometro">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <span v-case="'phmetro'" ref="'phmetro">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <span v-case="'manometro'" ref="'manometro">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <span v-case="'dosatore additivi'" ref="'dosatore additivi">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <span v-case="'dosatore additivi litri'" ref="'dosatore additivi litri">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <span v-case="'sonda umidità'" ref="'sonda umidità">
                <span v-for="(range, idx) in o_data.ranges" :key="idx"><span v-if="!!range.max && !!range.min">da {{ range.min | formatNumber}}{{ o_data.uom }} a {{ range.max | formatNumber}}{{ o_data.uom }} - d: {{range.d | formatNumber}}{{o_data.uom}}<br/></span></span></span>
            <div v-default>-</div>
            <v-divider v-if="show_divider"></v-divider>
        </div>
    </div>
</template>
<script>
// import _ from 'lodash'
import {i_families} from "../../../utils/common"
export default {
    props: {
        o_data: {
            type: Object,
            required: true
        },
        show_divider: {
            type: Boolean,
            required: false,
            default: true
        },
        show_class: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    return: {
        data: {
            families: {}
        }
    },
    beforeMount() {
        this.families = i_families
    },
    computed: {
        family() {
            return this.o_data.family
        },
        instr_class() {
            if (!_.isEmpty(this.families[this.o_data.family].class) && !!this.o_data.instrument_class ) {
                let i_cl = this.o_data.instrument_class
                let item = _.find(this.families[this.o_data.family].class, function(cl) { return cl.id == i_cl; });
                return item.text
            }
            return null
        }
    }
}
</script>